<template>
  <div class='view-wrapper'>

    <!-- 左側 メニュー -->
    <div class='menu-wrapper disp-scroll'>
      <b-collapse class="card" animation="slide">
        <div slot="trigger" slot-scope="props" class="card-header" role="button">
          <div class="card-header-title">日時 フィルター</div>
          <a class="card-header-icon"><b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon></a>
        </div>
        <!-- 日時 -->
        <div class="card-content date-wrapper">
          開始
          <div style="display: flex;">
            <b-datetimepicker
              class="datetimepick"
              rounded locale="ja-JP" size="is-small"
              :mobile-native="false" :append-to-body="true" :open-on-focus="true"
              placeholder="From" icon="calendar-today"
              v-model="filter_conditions.date.start">
            </b-datetimepicker>
            <span class='close mdi mdi-close-circle mdi-18px' @click="filter_conditions.date.start=null"></span>
          </div>
          終了
          <div style="display: flex;">
            <b-datetimepicker
              class="datetimepick"
              rounded locale="ja-JP" size="is-small"
              :mobile-native="false" :append-to-body="true" :open-on-focus="true"
              placeholder="To" icon="calendar-today"
              v-model="filter_conditions.date.end">
            </b-datetimepicker>
            <span class='close mdi mdi-close-circle mdi-18px' @click="filter_conditions.date.end=null"></span>
          </div>
        </div>
      </b-collapse>
      <!-- URL -->
      <b-collapse class="card" animation="slide">
        <div slot="trigger" slot-scope="props" class="card-header" role="button">
          <div class="card-header-title">URL フィルター</div>
          <a class="card-header-icon"><b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon></a>
        </div>
        <div class="card-content tree-wrapper">
          <SelectTree :contents="filter_conditions.url" :statusKey="'__select__'" :title="'All URL'" v-if="filter_conditions.url"></SelectTree>
        </div>
      </b-collapse>
      <!-- ユーザー -->
      <b-collapse class="card" animation="slide">
        <div slot="trigger" slot-scope="props" class="card-header" role="button">
          <div class="card-header-title">ユーザー フィルター</div>
          <a class="card-header-icon"><b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon></a>
        </div>
        <div class="card-content tree-wrapper">
          <SelectTree :contents="filter_conditions.users" :statusKey="'__select__'" :displayKey="'__display__'" :title="'All Users'" v-if="filter_conditions.users"></SelectTree>
        </div>
      </b-collapse>
      <!-- コンポーネント -->
      <b-collapse class="card" animation="slide">
        <div slot="trigger" slot-scope="props" class="card-header" role="button">
          <div class="card-header-title">コンポーネント フィルター</div>
          <a class="card-header-icon"><b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon></a>
        </div>
        <div class="card-content tree-wrapper">
          <SelectTree :contents="filter_conditions.components" :statusKey="'__select__'" :title="'All Components'" v-if="filter_conditions.components"></SelectTree>
        </div>
      </b-collapse>
      <!-- 読み込みサイズ -->
      <div class='size-select'>
        <span class='text-container'><p class='text'>読み込みサイズ</p></span>
        <b-select v-model="load_size">
          <option
            v-for="size in load_size_options"
            :value="size"
            :key="size">
            {{ size }}
          </option>
        </b-select>
      </div>

      <button class="button is-primary reload-btn" @click="reload">決定・再読み込み</button>
      <b-dropdown :triggers="['hover']" aria-role="list" style='margin-top: 8px;'>
            <template #trigger>
                <b-button
                    label="CSVエクスポート"
                    @click="export_csv(false)"/>
            </template>

            <b-dropdown-item aria-role="listitem" @click="export_csv(true)">全件エクスポート</b-dropdown-item>
        </b-dropdown>
    </div>

    <!-- 中央 ログリスト -->
    <div class='list-wrapper disp-scroll' @scroll="onScroll" ref='list_scroll'>
      <div class='list-outer-container'>
        <div class='list-inner-container'>
          <div v-for="(log, idx) in controlLogs" :key="idx">
            <div class='list-horizon' v-if="showDate(controlLogs[idx-1], controlLogs[idx])">
              {{formatDate(log.created_at)}}
            </div>
            <div :class="['list-item', {'list-item-selected': selected_log==log}]" @click="selectLog(log)">
              <div class="list-item-row">
                <div class="list-item-data">{{log.caption}}</div><div class="list-item-data">{{formatTime(log.created_at)}}</div>
              </div>
              <div class="list-item-row">
                <div class="list-item-data">{{formatURL(log.url)}}</div><div class="list-item-data">{{log.user_name}}</div>
              </div>
            </div>
          </div>
          <div class='list-horizon' v-if="controlLogComplete" style="padding-bottom: 8px;">
            END
          </div>
          <div class="mdi mdi-loading mdi-spin mdi-48px" v-if="controlLogLoading">
          </div>
        </div>
      </div>
    </div>

    <!-- 右側 詳細 -->
    <div class='detail-wrapper disp-scroll'>
      <div v-if="!selected_log"></div>
      <div class='detail-container' v-if="selected_log">
        <div class='detail-title'>{{selected_log.caption || '　'}}</div>
        <div class='detail-item'><div class='detail-item-name'>日時：</div><div class='detail-item-content'>{{formatDateTime(selected_log.created_at)}}</div></div>
        <div class='detail-item'><div class='detail-item-name'>ユーザー：</div><div class='detail-item-content'>{{selected_log.user_name}}</div></div>
        <div class='detail-item'><div class='detail-item-name'>UserAgent：</div><div class='detail-item-content'>{{formatUserAgent(selected_log.user_agent)}}</div></div>
        <div class='detail-item'><div class='detail-item-name'>URL：</div><div class='detail-item-content'>{{selected_log.url}}</div></div>
        <div style='height: 16px;'></div>
        <div>コンポーネント：</div>
        <div class='detail-cmp disp-scroll'>{{formatComponents(selected_log.vue_component)}}</div>
        <div style='height: 16px;'></div>
        <div>説明：</div>
        <div class='detail-desc disp-scroll'>{{selected_log.description}}<br><br>{{formatOptions(selected_log.options)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import parseUserAgent from '@/functions/parseUserAgent'
import SelectTree from '@/views/DashBoard/Operation/SelectTree'

export default {
  components: {
    SelectTree
  },
  data () {
    return {
      selected_log: null,
      filter_conditions: {
        date: {start: null, end: null},
        url: null,
        components: null,
        users: null
      },
      now_conditions: {},
      load_size: 25,
      load_size_options: [25,50,75,100,150,200]
    }
  },
  computed: {
    ...mapState('auth', ['controlLogs', 'controlLogFilterItems', 'controlLogLoading', 'controlLogComplete'])
  },
  watch: {
    controlLogFilterItems () {
      this.calcConditions()
    }
  },
  mounted () {
    this.$store.dispatch('auth/getControlLogFilterItems')
    this.$store.commit('auth/setControlLogLoading', true)
    this.now_conditions['size'] = this.load_size
    this.$store.dispatch('auth/getControlLogList', this.now_conditions)
  },
  methods: {
    calcConditions () {
      this.calcUserFilterCond()
      this.calcURLFilterCond()
      this.calcComponentFilterCond()
    },
    calcUserFilterCond () {
      let temp = {__select__: true}
      for (let user of this.controlLogFilterItems.users) {
        temp[user.id] = {__select__: true, __display__: user.name}
      }
      this.filter_conditions.users = temp
    },
    calcURLFilterCond () {
      let temp = {__select__: true}
      for (let url of this.controlLogFilterItems.url) {
        let routes = url.replace(/^\//, '').replace(/\/$/, '').split('/').map((route) => '/'+route.split('?')[0])
        let cur_route = temp
        for (let r of routes) {
          cur_route[r] = (cur_route[r] || {__select__: true})
          cur_route = cur_route[r]
        }
      }
      this.filter_conditions.url = temp
    },
    calcComponentFilterCond () {
      let temp = {__select__: true}
      for (let component of this.controlLogFilterItems.components) {
        let components = component.split(',')
        let cur_components = temp
        for (let c of components) {
          cur_components[c] = (cur_components[c] || {__select__: true})
          cur_components = cur_components[c]
        }
      }
      this.filter_conditions.components = temp
    },
    reload () {
      //条件を変えて再読み込み
      this.$store.commit('auth/initControlLogs')
      this.$store.commit('auth/setControlLogComplete', false)
      this.$store.commit('auth/setControlLogLoading', true)
      const conditions = {
        'size': this.load_size,
        'continue_date': null,
        'date': this.filter_conditions.date,
        'users': this.reverseUserFilterCond(this.filter_conditions.users),
        'url': this.reverseFilterCond(this.filter_conditions.url, (prt,cld) => {return prt+cld}),
        'components': this.reverseFilterCond(this.filter_conditions.components, (prt,cld) => {return prt+','+cld})
      }
      this.now_conditions = conditions
      this.$store.dispatch('auth/getControlLogList', conditions)
    },
    export_csv (all) {
      let conditions = {}
      if (all && !confirm('DB内の全ての操作履歴をエクスポートします。サイズが非常に大きくなる可能性があります。続行しますか？')) return
      if (all) {
        conditions = {'all': true}
      }
      else {
        conditions = {
          'date': this.filter_conditions.date,
          'users': this.reverseUserFilterCond(this.filter_conditions.users),
          'url': this.reverseFilterCond(this.filter_conditions.url, (prt,cld) => {return prt+cld}),
          'components': this.reverseFilterCond(this.filter_conditions.components, (prt,cld) => {return prt+','+cld})
        }
      }
      this.$store.dispatch('auth/exportControlLogs', conditions)
    },
    load_continue () {
      //続きを読み込み
      if (this.controlLogLoading) return
      if (this.controlLogComplete) return
      this.$store.commit('auth/setControlLogLoading', true)
      this.now_conditions['continue_date'] = this.controlLogs[this.controlLogs.length-1].created_at
      this.$store.dispatch('auth/getControlLogList', this.now_conditions)
    },
    reverseFilterCond (subset, concatFunc) {
      let ret = []
      const keys = Object.keys(subset).filter((key) => key!='__select__' && key!='__display__')
      for (let key of keys) {
        let temp = []
        if (subset[key].__select__ == true) temp = [[key]]
        if (subset[key].__select__ == undefined) {
          temp = this.reverseFilterCond(subset[key], concatFunc)
          temp = temp.map((item1) => item1.map((item2) => concatFunc(key,item2)))
          temp.splice(0,0,[])
        }
        
        if (ret.length < temp.length) ret = ret.concat([...Array(temp.length-ret.length)].map(()=>[]))
        ret = ret.map((item,idx) => item.concat(temp[idx] || []))
      }
      return ret
    },
    reverseUserFilterCond (users) {
      if (users.__select__) return Object.keys(users).filter((key) => key!='__select__' && key!='__display__')
      else return Object.keys(users).filter((key) => key!='__select__' && key!='__display__').filter((id) => users[id].__select__)
    },
    onScroll(event) {
      const clientHeight = this.$refs.list_scroll.clientHeight
      const scrollHeight = this.$refs.list_scroll.scrollHeight
      const scrollTop = this.$refs.list_scroll.scrollTop
      if (scrollHeight - clientHeight - scrollTop < 5) {
        this.load_continue()
      }
    },
    selectLog (log) {
      this.selected_log = log
    },
    showDate (before, after) {
      if (!after) return false
      if (!before) return true
      return this.formatDate(before.created_at) != this.formatDate(after.created_at)
    },
    formatTime (date) {
      return moment(date).format('HH:mm')
    },
    formatDate (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    formatDateTime (date) {
      return moment(date).format('YYYY/MM/DD(dd) HH:mm')
    },
    formatURL (url) {
      return url.split('?')[0]
    },
    formatUserAgent (userAgent) {
      const device = parseUserAgent.device(userAgent)
      const browser = parseUserAgent.browser(userAgent)
      return device + ' - ' + browser
    },
    formatComponents (components) {
      return components.split(',').join(' > ')
    },
    formatDescription (desc) {
      return desc.replace(/\r\n/g, '<br>');
    },
    formatOptions (options, indent=0) {
      let str = ''
      for (let key of Object.keys(options)) {
        if (this.$_.isPlainObject(options[key])) {
          str += '　'.repeat(indent) + key + '：\n' + this.formatOptions(options[key], indent+1)
        }
        else {
          str += '　'.repeat(indent) + key + '：' + options[key] + '\n'
        }
      }
      if (indent==0 && str !== '') str = '＜付加情報＞\n'+str
      return str
    }
  }
}
</script>

<style lang="scss" scoped>
.view-wrapper {
  padding: 0px !important;
  margin: 0px !important;
  height: 100vh;
  width: 100%;
  background-color: #ffffff;
  display: flex;
}

.menu-wrapper {
  width: 30%;
  box-shadow: 0px 0px 8px 0px gray;
  padding: 16px;

  .size-select {
    display: flex;
    padding-top: 16px;
    .text-container {
      padding: 0px 8px;
      .text {
        display: inline;
        vertical-align: middle;
      }
    }
  }
  .date-wrapper {
    padding: 8px;
    .datetimepick {
      width: calc(100% - 32px);
    }
    .close {
      margin-left: 8px;
      cursor: pointer;
    }
  }
  .tree-wrapper {
    padding: 8px 0px 8px 4px;
  }
  .reload-btn {
    margin-top: 8px;
  }
}

.list-wrapper {
  width: 40%;
  height: 100%;
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
  }
  .list-outer-container {
    width: 100%;
    height: 100%;
    .list-inner-container {
      width: 100%;
      vertical-align: middle;
      .list-item {
        height: 50px;
        width: 80%;
        margin-left: 10%;
        overflow: hidden;
        cursor: pointer;
        background: #ffeeff;
        border-radius: 8px;
        margin-bottom: 16px;

        .list-item-row {
          width: 100%;
          display: flex;
          .list-item-data {
            width: 50%;
            text-align: left;
            padding-left: 10%;
            white-space: nowrap;
            overflow-x: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .list-item-selected {
        background: #ffddff;
      }
      .list-horizon {
        display: flex;
        align-items: center;
        justify-content: center;
        &::before, &::after{
          border-top: 1px solid black;
          content: "";
          width: 200px;
        }
        &::before {
          margin-right: 16px; 
        }
        &::after {
          margin-left: 16px; 
        }
      }
    }
  }
}

.detail-wrapper {
  width: 30%;
  height: 100%;
  box-shadow: 0px 0px 8px 0px gray;
  background: #f0f0f0;
  text-align: left;

  .detail-container {
    margin: 16px 16px;
    height: 100%;
    .detail-title {
      font-size: 1.3em;
      padding-bottom: 8px;
    }
    .detail-item {
      display: flex;
      .detail-item-name {
        width: 100px;
      }
      .detail-item-content {
        width: calc(100% - 100px);
      }
    }
    .detail-cmp {
      white-space: nowrap;
      width: calc(100% - 16px);
      margin-left: 16px;
    }
    .detail-desc {
      white-space: pre-wrap;
      width: 100%;
      height: calc(100% - 300px);
      margin-top: 4px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/Operation/ControlLogView.vue